import { useSelector } from 'react-redux';

import { selectIsUuidBasedProject } from 'core/userContext';

export const useListsField = () => {
  const isUuidBased = useSelector(selectIsUuidBasedProject);
  return isUuidBased ? 'userListIds' : 'emailListIds';
};
